import { useState } from "react";
import { Ellipsis, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";

import ACL_RELATIONSHIPS from "acl-relationships";
import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import Authorized from "components/Authorized";
import SourceStatusForm from "components/forms/SourceStatusForm";
import ConfirmDeleteDialog from "components/modals/ConfirmDeleteDialog";
import FormDialog from "components/modals/FormDialog";
import { invalidateSourceStatusesQuery } from "hooks/useSourceStatusesTable";
import SourceStatusesService from "services/SourceStatus";

const EDIT_ACLS = [ACL_RELATIONSHIPS.sourceStatus.edit];
const DELETE_ACLS = [ACL_RELATIONSHIPS.sourceStatus.delete];
const ANY_ACLS = [...EDIT_ACLS, ...DELETE_ACLS];

export function SourceStatusesTableActions({ original }) {
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const handleDelete = async () => {
    try {
      await SourceStatusesService.delete(original.id);
      toast.success("Source Status deleted");
      setDeleteOpen(false);
      await invalidateSourceStatusesQuery();
    } catch {
      toast.error("Failed to delete Source Status");
    }
  };

  return (
    <Authorized permissions={ANY_ACLS} partialMatch>
      <>
        <DropdownMenu>
          <DropdownMenuTrigger
            aria-label="Source status actions"
            className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
          >
            <Ellipsis />
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <Authorized permissions={EDIT_ACLS}>
              <DropdownMenuItem onClick={() => setEditOpen(true)}>
                <Pencil />
                Edit
              </DropdownMenuItem>
            </Authorized>
            <Authorized permissions={DELETE_ACLS}>
              <DropdownMenuItem
                variant="destructive"
                onClick={() => setDeleteOpen(true)}
              >
                <Trash2 />
                Delete
              </DropdownMenuItem>
            </Authorized>
          </DropdownMenuContent>
        </DropdownMenu>
        <FormDialog
          FormComponent={SourceStatusForm}
          model={original}
          modelType="Source Status"
          open={editOpen}
          onOpenChange={setEditOpen}
          onSuccess={invalidateSourceStatusesQuery}
        />
        <ConfirmDeleteDialog
          open={deleteOpen}
          onOpenChange={setDeleteOpen}
          title="Delete Source Status?"
          description="Are you sure you want to delete this Source Status?"
          onConfirm={handleDelete}
        />
      </>
    </Authorized>
  );
}
